/*
    Форма информации о клиенте
*/



import './Find.css';
import '../css/Main.css';
import React, { useState, useEffect, useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import axios_sender from '../modules/axios_sender.js'
import get_element_from_class from '../modules/element.js'
import unique from '../modules/unique.js';
import SetGlobalClient from '../modules/client.js'
import ListShow from '../List/ListShow.js'
import SelectAnimalModal from '../Animals/SelectAnimalModal.js'
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';



var safeClientList = [];        // список всех животных
var saved_client = [];          // клиент, которого выбрали. В случае успешного выбора животного, клиент станет тоже выбранным

function Find(props) {
   

    const [ClientList, SetClientList] = useState([]);                   // фильтр поиска
    const [dop_search, SetDopSearch] = useState([]);                    // дополнительный фильтр поиска

    const [is_display_animal_select, SetDisplauAnimalselect] = useState(false); // показываит/скрывать выбор животного у клиента
    const [client, SetClient] = useState([]);                    // выбранный пользователь


    // если клиента создали из вне и здесь заранее его выбирают
    const location = useLocation();
    const { param } = location.state || {};     // Получаем параметр из состояния
    const selected_out_client = param;          // Получаем параметр из маршрута


    const navigate = useNavigate();

    
    useEffect(() => { LoadClients(); }, []);

    useEffect(() => VerifySelectedClient, []);        // если клиент уже выбран, то 

    const elementsRef = useRef();               // ссылка на элементы

  return ( <div ref= { elementsRef } >

            <div className="row">
                <div className="find-grid container-fluid row d-flex align-items-center justify-content-center col-9">
                        <div className="button cat" onClick={ (e) => SelectAnimalType(e, "Кошка") }></div>
                        <div className="button dog" onClick={ (e) => SelectAnimalType(e, "Собака") }></div>
                        <div className="button turtle" onClick={ (e) => SelectAnimalType(e, "Черепаха") }></div>
                        <div className="button rat" onClick={ (e) => SelectAnimalType(e, "Крыса") }></div>
                        <div className="button seapig" onClick={ (e) => SelectAnimalType(e, "Морская свинка") }></div>
                        <div className="button hamster" onClick={ (e) => SelectAnimalType(e, "Хомяк") }></div>                        
                </div>

                <NavLink to="/new_client" className="col-3" style={{ textDecoration: 'none' }}><div className="button-new-client">ДОБАВИТЬ КЛИЕНТА</div></NavLink>
            </div>

            
                <ListShow
                    CaptionPage="ПОИСК ВЛАДЕЛЬЦА"                           // заголовок для формы поиска
                    ListData={ ClientList }                                 // список всех клиентов
                    FilterList={ ['name', 'address', 'telephone'] }         // массив полей для поиска
                    FillOnePosition={ fillOneClient }                       // функция для прорисовки одной позиции
                    CancelFind={ CancelSelect }                             // функция для отмены выбора
                    InPage="20"                                             // сколько позиций на странице
                    DopSearch={ dop_search }                    
                    />

            { is_display_animal_select && (<SelectAnimalModal Client={ client } SelectedAnimalSuccess={ SelectedAnimalSuccess } CancelSelect={ CancelSelectAnimal }/>) }

    </div>
  );


  // загрузить клиентов
  async function LoadClients()
  {
        if(safeClientList.length > 0) { SetClientList(safeClientList); return; }
            axios_sender({form: 'get_clients_with_animals'}, LoadClientsSuccess);
  }
  function LoadClientsSuccess(data)
  {        
        var clients = [];
        for(var i in data)     
        {
            var d = data[i];

            var is_find = false;
            for(var j in clients)
                if(clients[j].ID == d.ID)
                {
                    clients[j].animal_types += ";" + d.animal_type;
                    clients[j].qty ++;
                    is_find = true;
                    break;
                }
            if(is_find == false)
            {
                var client = d;
                client.animal_types = d.animal_type;
                client.qty = 0;
                if(d.animal_type !== undefined && d.animal_type != null && d.animal_type != "") client.qty = 1;
                clients.push(client);
            }
        }
        safeClientList = clients;
        SetClientList(clients);
  }

  // возвращает строку одного клиента
  function fillOneClient(client)
  {    
        let animal_type = client.animal_type;
        if(client.qty > 1) animal_type += " + [...]";
        return <div key={unique()} className="one-client container-fluid row d-flex align-items-center">

                <div className="col-4" onClick={ () => SelectedClient(client) }>
                    <div className="fio">{ client.name }</div>
                
                </div>
                <div className="col-3">
                    <div className="address">{ client.address }</div>
                </div>
                <div className="col-2">
                    <div className="address">{ client.telephone }</div>
                </div>


                <div className="col-1">
                    <div className="qty">Жив.:{ client.qty }</div>
                </div>
                <div className="col-2">
                    <div className="type_animal">{ animal_type }</div>
                </div>

        </div>   
  }
  
  // пользователь выбрал клиента
  function SelectedClient(client)
  {
        saved_client = client;
        // покажем модальное окно выбора животного
        SetClient(client);
        SetDisplauAnimalselect(true);
  }
  // пользователь выбрал животное
  function SelectedAnimalSuccess(animal)
  {
        SetDisplauAnimalselect(false);          // закроем модальное окно
        props.SelectedAnimal(animal);           // отобразим животное в TopMenu

        SetGlobalClient(saved_client);          // сохраним выбор клиента
        props.SelectedClient(saved_client);     // отобразим клиента в TopMenu

        // перейдём на страницу истории животного
        navigate('/History', { state: { param: animal } });
  }
  // пользователь отказывается от выбора животного
  function CancelSelectAnimal() { SetDisplauAnimalselect(false); }


  // пользователь отказывается от выбора
  function CancelSelect() {  }

  // пользователь выбирает тип животного
  function SelectAnimalType(e, animal_type)
  {
        // найдём массив элементов с классом кнопки и покрасим фон в белый
        let els = get_element_from_class(elementsRef.current, 'button');    
        for(var i in els) els[i].style.backgroundColor = '#ffffff';


        if(animal_type == dop_search.value)
        {
            //e.target.style.backgroundColor = "";
            SetDopSearch([]);            
        }
        else
        {
            e.target.style.backgroundColor = "#234564";
            SetDopSearch({ field: 'animal_types', value: animal_type });
        }
  }


  function VerifySelectedClient()
  {    
        if(selected_out_client === undefined) return;
        console.log(selected_out_client);
        SelectedClient(selected_out_client);
  }

}


export default Find;
